import React from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import BtnBack from '../../../../btn-back'
import LabelCustomSmall from '../../../../label-custom-small'
import Fuel from './../../../../../images/Fuel.svg'
import { Image } from 'react-bootstrap'

export default function EmpWelfareCar() {
  return (
    <>
      <Card.Body className="overflow-auto">
        <BtnBack text={'สิทธิค่าเดินทาง'} className={''} />
        <Row className="mt-3">
          <Col>
            <div className="d-flex">
              <Image
                src={Fuel}
                className="me-3"
                style={{
                  height: '45px',
                  width: '45px'
                }}
              ></Image>{' '}
              <span className="my-auto">มีสิทธิ 1,000 บาทต่อเดือน</span>
            </div>
          </Col>
          <Col xl={12}>
            <Row>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>เลขทะเบียนรถ</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>เลขทะเบียนรถ</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>เลขทะเบียนรถ</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>เลขทะเบียนรถ</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
              <Form.Group className="mt-3 col-xl-3">
                <LabelCustomSmall>เลขทะเบียนรถ</LabelCustomSmall>
                <Form.Control value={''} />
              </Form.Group>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  )
}
